<template>
  <div>

    <nav class="navbar customNavbar" >
      <div class="navbar-brand">
        <a v-on:click="root()">
          <img class="logoClass" src="/static/logo.png">
        </a>
      </div>
      <div class="navbar-end">
        <a class="navbar-item customNavbarItem" v-on:click="root()">Inicio</a>
        <a class="navbar-item customNavbarItem" v-on:click="about()">Nosotros</a>
        <a class="navbar-item customNavbarItem" v-on:click="products()">Productos</a>
        <a class="navbar-item customNavbarItem" v-on:click="news()">Noticias</a>
        <a class="navbar-item customNavbarItem" v-on:click="contact()">Contacto</a>
        <a class="navbar-item customNavbarItem" v-if="isLogged" v-on:click="logout()">Cerrar Sesión</a>
        <a class="navbar-item customNavbarItem" v-else v-on:click="login()">Iniciar Sesión</a>
      </div>
    </nav>

    <section class="section">
      <div class="container">
        <img class="landingImage" src="/static/landing-collage.jpg">
      </div>
    </section>

    <section class="hero">
      <div class="hero-body">
        <div class="container">
          <carousel :autoplay="true" :perPage="1" :navigationEnabled="true" :loop="true" :autoplayTimeout="1500">
            <slide v-for="highlight of highlights" :key="highlight.id">
              <a v-on:click="productDetail(highlight.link)">
                <img class="sliderImg" :src="multimediaBase+highlight.imagePath" :alt="highlight.name" width="500px" height="200px"/>
              </a>
            </slide>
          </carousel>
        </div>
      </div>
    </section>

    <section class="section">
      <br/>
      <hr style="margin-bottom: 0">
      <br/>

      <div class="container">
        <h2 class="title is-3">Buscador</h2>
        <div class="columns">
          <div class="column"></div>
          <div class="column is-6">
            <form>
              <div class="field has-addons">
                <p class="control is-expanded">
                  <input v-model="search_landing" v-validate="'required'" data-vv-as="search" :class="{'input': true, 'is-danger': errors.has('search_landing') }" type="text" name="search_landing" />
                  <span v-show="errors.has('search_landing')" class="help is-danger">{{ errors.first('search_landing') }}</span>
                </p>
                <div class="control">
                  <button class="button customButton" v-on:click="search()">Buscar</button>
                </div>
              </div>
            </form>
          </div>
          <div class="column"></div>
        </div>
      </div>

      <br/>
      <hr class="newsDivider">
      <br/>

      <div class="container">
        <h2 class="title is-3">Noticias</h2>
        <div class="tile is-ancestor">
          <div class="tile is-parent" v-for="newsItem of latestNews" :key="newsItem.id">
            <article class="tile is-child box">
              <p class="title is-4">{{newsItem.title}}</p>
              <div class="content">
                <img v-if="newsItem.firstImage != null" :src="multimediaBase+newsItem.firstImage" width="150px" align="left" style="margin-right: 20px">
                <p class="newsInfo"><i>{{newsItem.dateStr}}</i> - {{newsItem.message}}</p>
              </div>
            </article>
          </div>
        </div>
      </div>

    </section>
    <FooterComponent/>
  </div>
</template>

<script>
import ApiClient from '@/api/ApiClient.js'
import FooterComponent from './FooterComponent'

export default {
  name: 'landing',
  components: {
    FooterComponent
  },
  data () {
    return {
      isLogged: localStorage.getItem('email') !== null,
      highlights: [],
      latestNews: [],
      search_landing: '',
      multimediaBase: '/multimedia/'
    }
  },
  methods: {
    root: function () {
      window.scrollTo(0, 0)
      this.$router.push('/')
    },
    logout: function () {
      localStorage.removeItem('email')
      localStorage.removeItem('token')
      this.isLogged = false
      this.$router.push('/')
    },
    about: function () {
      window.scrollTo(0, 0)
      this.$router.push('/about')
    },
    products: function () {
      window.scrollTo(0, 0)
      this.$router.push('/products')
    },
    news: function () {
      window.scrollTo(0, 0)
      this.$router.push('/news')
    },
    contact: function () {
      window.scrollTo(0, 0)
      this.$router.push('/contact')
    },
    login: function () {
      window.scrollTo(0, 0)
      this.$router.push('/login')
    },
    productDetail: function (link) {
      window.scrollTo(0, 0)
      this.$router.push(link)
    },
    getHighlights () {
      ApiClient.highlights().then(response => {
        if (response.data.success) {
          this.highlights = response.data.highlights
        }
      }).catch(error => {
        ApiClient.onError(error)
      })
    },
    getLatestNews () {
      ApiClient.latestNews().then(response => {
        if (response.data.success) {
          this.latestNews = response.data.news
        }
      }).catch(error => {
        ApiClient.onError(error)
      })
    },
    getData () {
      this.getHighlights()
      this.getLatestNews()
    },
    search () {
      console.log(this.search_landing)
      window.scrollTo(0, 0)
      this.$router.push('/search/' + this.search_landing)
    }

  },
  created () {
    this.getData()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .logoClass {
    height: 80px;
    width: 300px;
    margin-left: 20px;
    margin-top: 20px;
  }
  .landingImage {
    height: 320px;
    width: 530px;
  }
  .newsInfo {
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// LandingComponent.vue?4f32710e